import CryptoJS from "crypto-js";

/** Matches backend RequestSecurityUtil.APP_NUMBER_PATTERN. */
export const APPLICATION_NUMBER_PLAIN_PATTERN = /^[A-Za-z0-9-]{3,40}$/;

export const isPlainApplicationNumber = (value) => {
  const trimmed = String(value ?? "").trim();
  return trimmed.length > 0 && APPLICATION_NUMBER_PLAIN_PATTERN.test(trimmed);
};

const getJourneyEncryptionKey = () => {
  const key = import.meta.env.VITE_JOURNEY_QUERY_ENCRYPTION_KEY;
  return typeof key === "string" && key.trim() ? key.trim() : null;
};

export const encryptJourneyQueryValue = (plainText) => {
  const key = getJourneyEncryptionKey();
  const value = String(plainText ?? "").trim();
  if (!value) return "";

  if (!isPlainApplicationNumber(value)) return "";

  if (!key) return value;

  return CryptoJS.AES.encrypt(value, key).toString();
};

export const encryptJourneySensitiveValue = (plainText) => {
  const key = getJourneyEncryptionKey();
  const value = String(plainText ?? "").trim();
  if (!value) return "";
  if (!key) return value;
  return CryptoJS.AES.encrypt(value, key).toString();
};

export const decryptJourneyQueryValue = (cipherText) => {
  const key = getJourneyEncryptionKey();
  const value = String(cipherText ?? "").trim();
  if (!value) return "";
  if (!key) return value;

  try {
    const bytes = CryptoJS.AES.decrypt(value, key);
    const plain = bytes.toString(CryptoJS.enc.Utf8);
    return plain || "";
  } catch {
    return "";
  }
};
